import { Action } from 'redux';

export enum AuthActionTypes {
  LOGIN_WITH_GOOGLE_REQUEST = 'LOGIN_WITH_GOOGLE_REQUEST',
  LOGIN_WITH_GOOGLE_SUCCESS = 'LOGIN_WITH_GOOGLE_SUCCESS',
  LOGIN_WITH_GOOGLE_ERROR = 'LOGIN_WITH_GOOGLE_ERROR',
  SIGN_IN_WITH_COGNITO_REQUEST = 'SIGN_IN_WITH_COGNITO_REQUEST',
  SIGN_IN_WITH_COGNITO_SUCCESS = 'SIGN_IN_WITH_COGNITO_SUCCESS',
  SIGN_IN_WITH_COGNITO_ERROR = 'SIGN_IN_WITH_COGNITO_ERROR',
  SIGN_OUT_WITH_COGNITO_REQUEST = 'SIGN_OUT_WITH_COGNITO_REQUEST',
  SIGN_OUT_WITH_COGNITO_SUCCESS = 'SIGN_OUT_WITH_COGNITO_SUCCESS',
  SIGN_OUT_WITH_COGNITO_ERROR = 'SIGN_OUT_WITH_COGNITO_ERROR',
  LOGOUT_REQUEST = 'LOGOUT_REQUEST',
  LOGOUT_SUCCESS = 'LOGOUT_SUCCESS',
  LOGOUT_ERROR = 'LOGOUT_ERROR',
}

export interface AuthAction extends Action {
  type: AuthActionTypes;
  payload?: any;
  [key: string]: any;
}

export const signInWithCognitoRequestAction = (): AuthAction => {
  return {
    type: AuthActionTypes.SIGN_IN_WITH_COGNITO_REQUEST,
  };
};

export const signInWithCognitoSuccessAction = (payload: any): AuthAction => {
  return {
    type: AuthActionTypes.SIGN_IN_WITH_COGNITO_SUCCESS,
    payload,
  };
};

export const signInWithCognitoErrorAction = (payload: any): AuthAction => {
  return {
    type: AuthActionTypes.SIGN_IN_WITH_COGNITO_ERROR,
    payload,
  };
};

export const signOutWithCognitoRequestAction = (): AuthAction => {
  return {
    type: AuthActionTypes.SIGN_OUT_WITH_COGNITO_REQUEST,
  };
};

export const signOutWithCognitoSuccessAction = (): AuthAction => {
  return {
    type: AuthActionTypes.SIGN_OUT_WITH_COGNITO_SUCCESS,
  };
};

export const signOutWithCognitoErrorAction = (payload: any): AuthAction => {
  return {
    type: AuthActionTypes.SIGN_OUT_WITH_COGNITO_ERROR,
    payload,
  };
};

export const loginWithGoogleRequestAction = (): AuthAction => {
  return {
    type: AuthActionTypes.LOGIN_WITH_GOOGLE_REQUEST,
  };
};

export const loginWithGoogleSuccessAction = (payload: any): AuthAction => {
  return {
    type: AuthActionTypes.LOGIN_WITH_GOOGLE_SUCCESS,
    payload,
  };
};

export const loginWithGoogleErrorAction = (payload: any): AuthAction => {
  return {
    type: AuthActionTypes.LOGIN_WITH_GOOGLE_ERROR,
    payload,
  };
};

export const logoutRequestAction = (): AuthAction => {
  return {
    type: AuthActionTypes.LOGOUT_REQUEST,
  };
};

export const logoutSuccessAction = (): AuthAction => {
  return {
    type: AuthActionTypes.LOGOUT_SUCCESS,
  };
};

export const logoutErrorAction = (payload: any): AuthAction => {
  return {
    type: AuthActionTypes.LOGOUT_ERROR,
    payload,
  };
};  